import type { Prompt } from '../types';
import { extractVariables, substituteVariables } from './variables.ts';

export interface Variant {
  id: string;
  revision: number;
  source: { owner: string; repo: string; path: string; promptId: string };
  snapshot: Prompt;
}
export interface Comparison {
  id: string;
  caseId: string;
  variants: [Variant, Variant];
}
const id = () => crypto.randomUUID();
export function makeVariant(prompt: Prompt, source: Variant['source']): Variant {
  return { id: id(), revision: 1, source: { ...source }, snapshot: structuredClone(prompt) };
}
export function createComparison(a: Variant, b: Variant): Comparison {
  return { id: id(), caseId: id(), variants: [a, b] };
}
export function editVariant(variant: Variant, snapshot: Prompt): Variant {
  if (JSON.stringify(variant.snapshot) === JSON.stringify(snapshot)) return variant;
  return { ...variant, revision: variant.revision + 1, snapshot: structuredClone(snapshot) };
}
export function inputNames(variants: Variant[]): string[] {
  return [...new Set(variants.flatMap(({ snapshot }) => [
    ...(snapshot.variables || []).map(v => v.name),
    ...extractVariables(snapshot.prompts.system || ''), ...extractVariables(snapshot.prompts.user),
  ]))];
}
export function missingRequired(variant: Variant, values: Record<string, string>): string[] {
  return (variant.snapshot.variables || []).filter(v => v.required && !(values[v.name] || '').trim()).map(v => v.name);
}
export function renderVariant(variant: Variant, values: Record<string, string>): string {
  return [variant.snapshot.prompts.system, variant.snapshot.prompts.user]
    .filter((text): text is string => Boolean(text))
    .map(text => substituteVariables(text, values)).join('\n\n');
}
